import { createContext, useState, useEffect } from 'react';
import translations from '../translations';

export const LanguageContext = createContext();

export const LanguageContextProvider = ({ children }) => {
  // Check if user has a language preference in localStorage
  const [language, setLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem('language');
    // Default to browser language or English if not available
    if (!savedLanguage) {
      const browserLang = navigator.language.split('-')[0];
      return translations[browserLang] ? browserLang : 'en';
    }
    return savedLanguage;
  });

  // Update localStorage when language changes
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Get translations for the current language
  const t = translations[language] || translations.en;

  // Change language
  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
    }
  };

  // Get available languages
  const getAvailableLanguages = () => {
    return Object.keys(translations).map(code => ({
      code,
      name: code === 'en' ? 'English' : code === 'pl' ? 'Polski' : code
    }));
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, getAvailableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
}; 